"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWaypointBlockStats = exports.getWaypointEditableBlockType = exports.WAYPOINT_HEADING_REGEX = exports.WAYPOINT_EDITABLE_BLOCK_TYPES = void 0;
const emails_1 = require("../constants/emails");
const email_1 = require("./email");
const waypointBlocks_1 = require("./waypointBlocks");
exports.WAYPOINT_EDITABLE_BLOCK_TYPES = [
    "Html",
    "Heading",
    "Container",
    "ColumnsContainer",
    "Divider",
    "Image",
    "Button",
    "Spacer",
    "Socials",
    "Video",
    "CustomHTML",
];
exports.WAYPOINT_HEADING_REGEX = /^<(h[1-4])(\s[^>]*)?>(.*)$/is;
const isEditableBlockType = (type) => exports.WAYPOINT_EDITABLE_BLOCK_TYPES.includes(type);
const getWaypointEditableBlockType = (block) => {
    if (block.type !== "Html") {
        return isEditableBlockType(block.type) ? block.type : null;
    }
    const contents = block.data?.props?.contents;
    if ((0, email_1.isCustomHtmlBlock)(contents)) {
        return "CustomHTML";
    }
    if ((0, email_1.isSocialsBlock)(contents)) {
        return "Socials";
    }
    if ((0, email_1.isVideoBlock)(contents)) {
        return "Video";
    }
    if (exports.WAYPOINT_HEADING_REGEX.test((0, email_1.stripEmailWrapperRegex)(contents))) {
        return "Heading";
    }
    return "Html";
};
exports.getWaypointEditableBlockType = getWaypointEditableBlockType;
const getWaypointBlockStats = (blocks) => {
    const rootBlock = blocks[emails_1.WAYPOINT_ROOT_BLOCK_ID];
    if (rootBlock?.type !== "EmailLayout") {
        return null;
    }
    const blockTypeCounts = Object.fromEntries(exports.WAYPOINT_EDITABLE_BLOCK_TYPES.map((type) => [type, 0]));
    const blockIds = (0, waypointBlocks_1.getChildrenIdsFromBlock)(rootBlock).flatMap((childId) => (0, waypointBlocks_1.getAllBlockIdsToDelete)(childId, blocks));
    for (const blockId of blockIds) {
        const block = blocks[blockId];
        const blockType = block ? (0, exports.getWaypointEditableBlockType)(block) : null;
        if (blockType) {
            blockTypeCounts[blockType] += 1;
        }
    }
    return {
        block_count: Object.values(blockTypeCounts).reduce((total, count) => total + count, 0),
        block_types: exports.WAYPOINT_EDITABLE_BLOCK_TYPES.filter((type) => blockTypeCounts[type] > 0),
        block_type_counts: blockTypeCounts,
    };
};
exports.getWaypointBlockStats = getWaypointBlockStats;
